/*
<summary>
   This enum defines the tool_loan_details.loan_status values (AddToolLoanDetails API).
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum LoanStatusEnum {
  Active = 'ACTIVE',
  Returned = 'RETURNED',
  Overdue = 'OVERDUE',
}

export default LoanStatusEnum;
